import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:3000/api';

export interface CaptureMetricsLeadPayload {
  cnpj: string;
  channel: string;
  source?: string;
  medium?: string;
  campaign?: string;
  customerName?: string;
  phone?: string;
  email?: string;
  notes?: string;
  metadata?: Record<string, any>;
  loyaltyCustomerId?: string;
}

export async function captureMetricsLead(payload: CaptureMetricsLeadPayload) {
  try {
    const response = await axios.post(`${API_URL}/metrics/leads`, payload);
    return response.data;
  } catch (error) {
    // Evita que falhas de captura travem o fluxo do usuário
    if (process.env.NODE_ENV !== 'production') {
      console.warn('Falha ao capturar lead de métricas', error);
    }
    throw error;
  }
}
